import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatPhoneNumber'
})
export class FormatPhoneNumberPipe implements PipeTransform {
  transform(value: string, format: string = '+X (XXX) XXX-XXXX'): string {
    if (!value) return '';

    // Remove non-numeric characters
    const cleanValue = value.replace(/\D/g, '');

    // Extract last 10 digits as the phone number
    const phoneNumber = cleanValue.slice(-10);

    // Extract the international code (anything before the last 10 digits)
    const internationalCode = cleanValue.length > 10 ? cleanValue.slice(0, -10) : '';

    // Format output
    let formattedPhone = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
    if (internationalCode) {
      formattedPhone = `+${internationalCode} ${formattedPhone}`;
    }

    return formattedPhone;
  }
}
